import { render, staticRenderFns } from "./DeepLinkController.vue?vue&type=template&id=2b2c7ea2&scoped=true&"
import script from "./DeepLinkController.vue?vue&type=script&lang=js&"
export * from "./DeepLinkController.vue?vue&type=script&lang=js&"
import style0 from "./DeepLinkController.vue?vue&type=style&index=0&id=2b2c7ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c7ea2",
  null
  
)

export default component.exports